export const FONT_COLOR = {
  MAIN_COLOR: '#636466',
};
